<template>
  <div class="w-full gap-2 flex flex-col">
    <div class="h-[6px] w-full relative rounded-xl">
      <div class="absolute left-0 top-0 h-full w-full gap-2 flex z-[1]">
        <div
          v-for="(historyItem, historyItemIndex) of exercises.history"
          :key="historyItemIndex"
          class="scale-in h-full last:rounded-r-xl rounded-xl"
          :class="{
            'bg-error/50': !historyItem.isCorrect,
            'bg-success/50': historyItem.isCorrect
          }"
          :style="`width: ${100 / max}%`"
        />

        <div
          v-for="n of max - exercises.history.length"
          :key="`placeholder-${n}`"
          class="fade-in h-full rounded-xl bg-[#D9D9D9]"
          :style="{
            width: `${100 / max}%`,
            'animation-delay': `${n * 50}ms`
          }"
        />
      </div>
    </div>

    <div class="w-full flex justify-end">
      <span class="text-xs text-[#A1A1A1]">
        {{
          $t('hub.exercises.progress.exercise', {
            current: index + 1,
            total: max
          })
        }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'HubExercisesProgress',

  props: {
    max: { type: Number, default: 0 },
    index: { type: Number, default: 0 }
  },

  computed: {
    ...mapState('exercises', ['exercises'])
  }
}
</script>

<style scoped lang="scss">
@keyframes fade-in {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  animation: fade-in 0.25s ease-out forwards;
}

@keyframes scale-in {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}

.scale-in {
  animation: scale-in 0.25s ease-out;
}
</style>
